import { AuthService } from './auth/auth.service';
import { Component } from '@angular/core';
import { ConfirmationService } from 'primeng/primeng';
import { Router } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {

    isActive = false;
    showMenu = '';
    myData: Array<any>;

    constructor (public authService: AuthService,
        private confirmationService: ConfirmationService,
        private router: Router) {
    }

    logout() {
        this.confirmationService.confirm({
            message: 'Tem certeza que deseja sair do Flag?',
            accept: () => {
                this.router.navigate(['/login']);
                this.authService.logout();
            }
        });
    }
}




// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/app.component.ts